var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDensityStandard = function SvgDensityStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M3.563 17.977C1.524 17.977.5 16.972.5 14.963V3.043C.5 1.033 1.524.02 3.563.02h16.874c2.049 0 3.063 1.014 3.063 3.023v11.92c0 2.009-1.014 3.014-3.063 3.014zM2.07 3.13v5.082h19.86V3.13c0-1.014-.547-1.541-1.512-1.541H3.582c-.975 0-1.512.527-1.512 1.541m1.512 13.275h16.836c.965 0 1.512-.517 1.512-1.531V9.783H2.07v5.092c0 1.014.537 1.531 1.512 1.531"
  })));
};
export default SvgDensityStandard;